import { render, staticRenderFns } from "./ArrowButton.vue?vue&type=template&id=5e532f78&scoped=true&"
import script from "./ArrowButton.vue?vue&type=script&lang=js&"
export * from "./ArrowButton.vue?vue&type=script&lang=js&"
import style0 from "./ArrowButton.vue?vue&type=style&index=0&id=5e532f78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e532f78",
  null
  
)

export default component.exports